export default class Rendivo {
  static getProductRender(width: number, productId: string) {
    return `https://domainensw.rendivo.com/product/${productId}/image?loc=nsw&width=${width}`;
  }

  // Build the URL to a rendivo facade render
  static getFacadeFinishRender(
    width: number,
    productId: string,
    style: string | null,
    finishId: string,
    isFlipped: boolean
  ) {
    const orientation = isFlipped ? "left" : "right";
    let url = `https://domainensw.rendivo.com/product/${productId}/image?loc=nsw&width=${width}&orientation=${orientation}`;
    if(style != null){
      url += `&style=${style}`;
    }
    if(finishId != ""){
      url += `&theme=${finishId}`;
    }
    return url;
  }
  
  static getExteriorRender(
    width: number,
    productId: string,
    style: string | null,
    finishId: string,
    colourId: string,
    roofId: string,
    gutterId: string,
    windowId: string,
    isFlipped: boolean
  ) {
    const orientation = isFlipped ? "left" : "right";
    let url = `https://domainensw.rendivo.com/product/${productId}/image?loc=nsw&width=${width}&orientation=${orientation}`;
    if(style != null){
      url += `&style=${style}`;
    }
    if(finishId != ""){
      url += `&theme=${finishId}`;
      if(colourId != ""){
        url += `,${colourId}`;
      }
      if(roofId != ""){
        url += `,${roofId}`;
      }
      if(gutterId != ""){
        url += `,${gutterId}`;
      }
      if(windowId != ""){
        url += `,${windowId}`;
      }
    }
    return url;
  }

  static getFacadeFinishRenderSrcset(
    maxWidth: number,
    productId: string,
    style: string | null,
    finishId: string,
    isFlipped: boolean
  ) {
    let srcset = "";
    const widths = [1200, 1000, 800, 768, 600, 480, 400];
    for (const w of widths) {
      const widthToPass = maxWidth >= w ? w : maxWidth;
      srcset = srcset + this.getFacadeFinishRender(widthToPass, productId, style, finishId, isFlipped) + " "+widthToPass+"w,";
    }
    srcset = srcset.slice(0, -1);
    return srcset;
  }

  static getExteriorRenderSrcset(
    maxWidth: number,
    productId: string,
    style: string | null,
    finishId: string,
    colourId: string,
    roofId: string,
    gutterId: string,
    windowId: string,
    isFlipped: boolean
  ) {
    let srcset = "";
    const widths = [1640, 1200, 1000, 800, 768, 600, 480, 400];
    for (const w of widths) {
      const widthToPass = maxWidth >= w ? w : maxWidth;
      srcset = srcset + this.getExteriorRender(widthToPass, productId, style, finishId, colourId, roofId, gutterId, windowId, isFlipped) + " "+widthToPass+"w,";
    }
    srcset = srcset.slice(0, -1);
    return srcset;
  }

  static getSrcsetFromRendivoUrl(
    url: string,
    maxWidth: number,
  ) {
    const baseUrl = url.split("?")[0];
    const urlParams = new URLSearchParams(url.split("?").pop());
    let srcset = "";
    const widths = [1640, 1200, 1000, 800, 768, 600, 480, 400];
    for (const w of widths) {
      const widthToPass = maxWidth >= w ? w : maxWidth;
      urlParams.set("width", widthToPass.toString());
      srcset = srcset + baseUrl + "?" + urlParams.toString() + " "+widthToPass+"w,";
    }
    srcset = srcset.slice(0, -1);
    return srcset;
  }
}
